module.exports = __webpack_public_path__ + "cloud-5.svg?207b8b3115ce028592b94fa669fd296b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-5.svg
// module id = 43
// module chunks = 0